import { SEO } from '@/components/SEO';

export function TermsPage() {
  return (
    <>
      <SEO
        title="Terms of Service - Nestor"
        description="Terms and conditions for using Nestor services."
      />

      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">Last updated: January 24, 2026</p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using Nestor, you accept and agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Service Description</h2>
            <p>
              Nestor provides cloud-based human resource management software including employee management,
              payroll, attendance tracking, performance management, and related services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
              <li>Not interfere with or disrupt the service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Payment Terms</h2>
            <p>
              Fees are billed in advance on a monthly or annual basis. All fees are non-refundable except as
              required by law. We reserve the right to change our fees with 30 days notice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Termination</h2>
            <p>
              Either party may terminate this agreement at any time with written notice. Upon termination,
              you will have 30 days to export your data before it is permanently deleted.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">6. Limitation of Liability</h2>
            <p>
              Nestor shall not be liable for any indirect, incidental, special, consequential or punitive
              damages resulting from your use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">7. Contact</h2>
            <p>
              For questions about these Terms, contact us at legal@hrms.com
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
